import React, { useEffect, useState } from "react";
import API_URL from "../config";
import { useIdioma } from "../context/IdiomaContext";
import { useEstilo } from "../context/EstiloContext";
import { obtenerEstilo } from "../temas/catalogoEstilos";
import CargandoSpinner from "./CargandoSpinner";

const getContrasteColor = (hexColor) => {
  if (!hexColor) return "#000000";

  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);

  const luminance =
    (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.6 ? "#000000" : "#ffffff";
};

const KinderProfesoresList = ({
  onSeleccionar,
  servicioActual,
}) => {
  const { t } = useIdioma();
  const estiloGlobal = useEstilo();
  const estilo = servicioActual?.estilo_visual ? obtenerEstilo(servicioActual.estilo_visual) : estiloGlobal;
  const [profesores, setProfesores] = useState([]);
  const [etiquetasServicio, setEtiquetasServicio] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [loading, setLoading] = useState(true);

  const fondo =
    servicioActual?.color_fondo || "#f0f4ff";

  const colorPrincipal =
    servicioActual?.color || "#38bdf8";

  const colorContraste =
    getContrasteColor(fondo);

  useEffect(() => {
    const cargarTodo = async () => {
      try {
        setLoading(true);

        /* =========================
           PROFESORES
        ========================= */
        const resProfes = await fetch(
          `${API_URL}/api/profesores`
        );

        if (!resProfes.ok) {
          throw new Error("Error cargando profesores");
        }

        const dataProfes = await resProfes.json();

        /* =========================
           ETIQUETAS DE ESTE SERVICIO
           (antes se comparaba el nombre exacto "kindergarten" como texto;
           ahora se define en "Gestionar Etiquetas Docentes" → "Etiquetas
           por servicio", así renombrar la etiqueta ya no rompe nada)
        ========================= */
        let idsEtiquetasServicio = [];

        if (servicioActual?.id) {
          const resEtiquetas = await fetch(
            `${API_URL}/api/etiquetas-docentes/servicio/${servicioActual.id}`
          );
          const dataEtiquetas = await resEtiquetas.json();
          idsEtiquetasServicio = (dataEtiquetas || []).map((e) => e.id);
        }

        setEtiquetasServicio(idsEtiquetasServicio);

        /* =========================
           RESUMEN HORARIOS
        ========================= */
        const resResumen = await fetch(
          `${API_URL}/api/horarios/resumen-profesores?servicio_id=${servicioActual?.id || ""}`
        );

        if (!resResumen.ok) {
          throw new Error("Error cargando resumen");
        }

        const resumen = await resResumen.json();

        /* =========================
           UNIR DATOS
        ========================= */
        const profesoresFinal =
          dataProfes.map((prof) => {
            const dataDisp = resumen.find(
              (r) =>
                Number(r.profesor_id) ===
                Number(prof.id)
            );

            const cantidad = dataDisp
              ? Number(dataDisp.cantidad)
              : 0;

            return {
              ...prof,
              horariosDisponibles: cantidad,
              disponible: cantidad > 0,
            };
          });

        setProfesores(profesoresFinal);

      } catch (error) {
        console.error(
          "ERROR CARGANDO PROFESORES:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    cargarTodo();
}, [API_URL, servicioActual]);

  /* =========================
     FILTRO KINDER
  ========================= */
  const profesoresFiltrados =
    profesores.filter((prof) => {

      const coincideNombre =
        (prof.nombre || "")
          .toLowerCase()
          .includes(filtro.toLowerCase());

      return (
        coincideNombre &&
        etiquetasServicio.includes(prof.etiqueta_id)
      );
    });

  if (loading) {
    return <CargandoSpinner texto={t("kinder_cargando")} color={colorContraste} />;
  }



  return (
    <div
      className="kinder-contenedor"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        fontFamily: "Poppins",
        background: "transparent",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <h1
        className="kinder-titulo"
        style={{
          fontSize: "36px",
          color: colorContraste,
          fontWeight: "900",
          marginBottom: "25px",
          textShadow:
            "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >
        {t("kinder_titulo")}
      </h1>

      <input
        className="kinder-buscador"
        type="text"
        placeholder={t("kinder_buscar")}
        value={filtro}
        onChange={(e) =>
          setFiltro(e.target.value)
        }
        style={{
          padding: "14px 24px",
          borderRadius: "50px",
          border: "none",
          width: "min(320px, 90%)",
          boxShadow:
            "0 8px 25px rgba(0,0,0,0.15)",
          marginBottom: "50px",
        }}
      />

      {estilo.layoutDocentes === "lista" ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 12, width: "100%", maxWidth: 720 }}>
          {profesoresFiltrados.map((profe, index) => (
            <div
              key={profe.id}
              style={{
                background: "white",
                borderRadius: estilo.cardRadius,
                boxShadow: estilo.cardShadow,
                border: estilo.cardBorder,
                borderLeft: `4px solid ${profe.disponible ? "#16a34a" : "#dc2626"}`,
                padding: "12px 16px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                textAlign: "left",
                animation: "fadeUp .6s ease forwards",
                animationDelay: `${index * 0.08}s`,
                opacity: 0,
              }}
            >
              <img
                src={profe.foto || `${API_URL}/Fotos_profesores/default.png`}
                onError={(e) => { e.currentTarget.src = `${API_URL}/Fotos_profesores/default.png`; }}
                alt={profe.nombre}
                style={{
                  width: estilo.fotoTamano,
                  height: estilo.fotoTamano,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: `3px solid ${colorPrincipal}`,
                  flexShrink: 0,
                }}
              />

              <div style={{ flex: 1, minWidth: 0 }}>
                <h3 style={{ fontWeight: 700, fontSize: 15, margin: 0 }}>{profe.nombre}</h3>
                <p style={{ fontSize: 12, color: "#666", margin: "2px 0" }}>{profe.email}</p>
                <p style={{ fontSize: 12, fontWeight: 700, margin: 0, color: profe.disponible ? "#16a34a" : "#dc2626" }}>
                  {profe.disponible
                    ? `${profe.horariosDisponibles} ${t("kinder_disponibles")}`
                    : `0 ${t("kinder_disponibles")}`}
                </p>
              </div>

              <button
                disabled={!profe.disponible}
                onClick={() => onSeleccionar && onSeleccionar(profe)}
                style={
                  estilo.botonEstilo === "outline"
                    ? {
                        background: "white",
                        color: profe.disponible ? colorPrincipal : "#999",
                        border: `2px solid ${profe.disponible ? colorPrincipal : "#ccc"}`,
                        borderRadius: estilo.botonRadius,
                        padding: "10px 18px",
                        fontWeight: "bold",
                        cursor: profe.disponible ? "pointer" : "not-allowed",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }
                    : {
                        background: profe.disponible ? colorPrincipal : "#ccc",
                        color: "#fff",
                        border: "none",
                        borderRadius: estilo.botonRadius,
                        padding: "10px 18px",
                        fontWeight: "bold",
                        cursor: profe.disponible ? "pointer" : "not-allowed",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }
                }
              >
                {t("kinder_ver_horarios")}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(260px,260px))",
            justifyContent: "center",
            gap: "35px",
            width: "100%",
            maxWidth: "1100px",
          }}
        >
          {profesoresFiltrados.map(
            (profe, index) => (
              <div
                key={profe.id}
                style={{
                  background:
                    estilo.key === "minimalista"
                      ? "white"
                      : "rgba(255,255,255,0.75)",
                  backdropFilter: estilo.key === "minimalista" ? "none" : "blur(12px)",
                  WebkitBackdropFilter: estilo.key === "minimalista" ? "none" : "blur(12px)",
                  borderRadius: estilo.cardRadius,
                  padding: "30px 25px",
                  border: estilo.key === "minimalista" ? estilo.cardBorder : `1px solid ${colorPrincipal}25`,
                  boxShadow: estilo.cardShadow,
                  animation:
                    "fadeUp .6s ease forwards",
                  animationDelay: `${index * 0.08}s`,
                  opacity: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >

<img
  src={
    profe.foto ||
    `${API_URL}/Fotos_profesores/default.png`
  }
  onError={(e) => {
    e.currentTarget.src =
      `${API_URL}/Fotos_profesores/default.png`;
  }}
  alt={profe.nombre}

                  style={{
                    width: estilo.fotoTamano,
                    height: estilo.fotoTamano,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: `4px solid ${colorPrincipal}`,
                    boxShadow:
                      "0 8px 20px rgba(0,0,0,0.25)",
                  }}
                />
              </div>

              <h3
                style={{
                  marginTop: "18px",
                  fontWeight: 700,
                }}
              >
                {profe.nombre}
              </h3>

              <p
                style={{
                  fontSize: "13px",
                  color: "#666",
                }}
              >
                {profe.email}
              </p>

              <button
                disabled={!profe.disponible}
                onClick={() =>
                  onSeleccionar &&
                  onSeleccionar(profe)
                }
                style={
                  estilo.botonEstilo === "outline"
                    ? {
                        marginTop: "18px",
                        background: "white",
                        color: profe.disponible ? colorPrincipal : "#999",
                        border: `2px solid ${profe.disponible ? colorPrincipal : "#ccc"}`,
                        padding: "13px 26px",
                        borderRadius: estilo.botonRadius,
                        fontWeight: "bold",
                        cursor: profe.disponible ? "pointer" : "not-allowed",
                      }
                    : {
                        marginTop: "18px",
                        background:
                          profe.disponible
                            ? colorPrincipal
                            : "#ccc",
                        color: "#fff",
                        border: "none",
                        padding: "13px 26px",
                        borderRadius: estilo.botonRadius,
                        fontWeight: "bold",
                        cursor:
                          profe.disponible
                            ? "pointer"
                            : "not-allowed",
                        boxShadow:
                          "0 8px 18px rgba(0,0,0,0.25)",
                      }
                }
              >
                {t("kinder_ver_horarios")}
              </button>

              <div
                style={{
                  marginTop: "12px",
                  background:
                    profe.disponible
                      ? "#16a34a"
                      : "#dc2626",
                  color: "#fff",
                  padding: "8px 14px",
                  borderRadius: "12px",
                  fontSize: "13px",
                  fontWeight: "700",
                  display: "inline-block",
                }}
              >
                {profe.disponible
                  ? `${profe.horariosDisponibles} ${t("kinder_disponibles")}`
                  : `0 ${t("kinder_disponibles")}`}
              </div>
              </div>
            )
          )}
        </div>
      )}

      <style>{`
        @keyframes fadeUp{
          from{
            transform:translateY(25px);
            opacity:0;
          }
          to{
            transform:translateY(0);
            opacity:1;
          }
        }
        @media (max-width: 480px) {
          .kinder-contenedor {
            padding: 14px 12px !important;
          }
          .kinder-titulo {
            font-size: 22px !important;
            margin-bottom: 10px !important;
          }
          .kinder-buscador {
            padding: 10px 18px !important;
            margin-bottom: 18px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default KinderProfesoresList;